"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const apiErrorToErrorMessage_1 = __importDefault(require("./apiErrorToErrorMessage"));
const formatErrorMessage_1 = __importDefault(require("./formatErrorMessage"));
function errorMessageFromFormErrors(errors, submitError) {
    // Redux-form processes and returns form submission errors as follows:
    //  + If form validation errors were raised without any external interaction
    //    (e.g., no API call) then "errors" will be set with a property set for each
    //    validation error and "submitError" will be undefined.
    //  + If form validation errors were raised due to custom validations generating
    //    a SubmissionError against a form field, both "errors" and "submitError"
    //    will be defined. Note that this case is differentiated by the content
    //    of the SubmissionError. See the external errors case below.
    //  + If external errors were raised, "submitError.meta.error.response.errorCode" is
    //    set and "submitError" will be defined with an SubmissionError instance whose
    //    "meta.error" property contains the contents of the HttpError.
    //
    // If validation errors have been raised, this function will return either the
    // overall form validation error (errors_error) if it has been set or a generic
    // message. Otherwise, if external errors were raised, this function will return
    // the value of apiErrorToErrorMessage() called with errors._error.
    const hasValidationErrors = !(0, lodash_1.isEmpty)(errors) && (0, lodash_1.isEmpty)(submitError);
    const hasCustomValidationErrors = submitError?.meta?.error?.name !== 'HttpError';
    const { _error: formWideError } = errors;
    // The following message is returned from the API infrastructure during form
    // submission when a server error occurs. Do not display this message to the user...
    if (formWideError === "Cannot read properties of undefined (reading 'status')")
        return;
    if (hasValidationErrors || hasCustomValidationErrors) {
        return (formWideError ??
            'Please review the information provided and correct all form errors');
    }
    return (0, apiErrorToErrorMessage_1.default)(submitError?.meta?.error?.response?.errorCode, (0, formatErrorMessage_1.default)(submitError?.meta?.error?.response?.message));
}
exports.default = errorMessageFromFormErrors;
